import React from 'react';

import styled from 'styled-components';

import LoaderRibbed from '../../lib/LoaderRibbed';

export const RemoveIconContainer = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  z-index: 100;
  background: var(--text-primary);
  cursor: pointer;
`;

export const ThumbnailContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  width: 134px;
  height: 134px;

  border: 1px solid var(--line-gray);
  background-color: var(--background-gray-light);
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  span {
    font-size: 12px;
    color: var(--text-secondary);
  }
`;

export const ThumbnailLoader = () => {
  return (
    <LoaderContainer>
      <LoaderRibbed size={'small'} />
      <span>Uploading</span>
    </LoaderContainer>
  );
};
